import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import {QuestionBase} from "../../../../core/components/dynamic-form/models/question-base";

export class FascicoloAzioneMonitoria extends FascicoloFull {
  sezione: string;
  numDecretoIngiuntivo: string;
  numRegistroGenerale: string;
  dataEmissioneDecretoIngiuntivo: number;
  dataDepositoDecretoIngiuntivo: number;
  dataRichiestaApposizione: number;
  dataRitiroCopie: number;
  dataApposizioneFormulaEsecutiva: number;
  cancelliere: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([
      {
        key: 'grado',
        label: 'Grado',
        required: false,
        controlType: 'dropdown',
        placeholder: 'Inserire Grado',
        size: 'sm-4',
        value: this.grado
      },
      {
        key: 'autoritaGiudiziaria',
        label: 'Autorità giudiziaria',
        required: true,
        controlType: 'dropdown',
        placeholder: 'Inserire Grado',
        size: 'sm-4',
        value: this.autoritaGiudiziaria
      },
    ] as QuestionBase[]);
  }
}
